<template>
  <div class="view-floating-nav">
    <cms-floating-nav
      v-if="floatingNavSetUp"
      :theme="floatingNavOptions"
      :floating-nav="homepage.floating_nav"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../stores/mainStore.js';
import { useTranslationStore } from '../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);

const floatingNavOptions = computed(() => ({
  ...theme.value.floating_nav.options,
  translations: translationStore.getComponentTranslation('floating_nav'),
  globalThemeSettings: mainStore.getGlobalThemeSettings,
}));

const floatingNavSetUp = computed(() => homepage.value.floating_nav && !isEmpty(homepage.value.floating_nav.buttons));
</script>
